<template>
  <div class="bottomBar">
    <v-toolbar color="secondary" :height="$vuetify.breakpoint.mobile ? 250 : 170">
      <v-container :class="$vuetify.breakpoint.mobile ? 'pa-0':''">
        <v-row>
          <v-col cols="12" md="4"
                 :class="'offset-md-2' + ($vuetify.breakpoint.mobile ? ' logo':'')">
            <v-img src="../../../assets/logo-white.svg" :alt="$store.state.text.app.appTitle"
                   height="100" contain/>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="5">
                <p v-for="(menu, index) in $store.state.text.pages.bottomMenu.left"
                   class="bottomMenu ma-0 pointer"
                   :key="menu.name + index"
                   @click="$router.push(menu.link)">
                  {{ menu.name }}
                </p>
              </v-col>
              <v-col cols="5">
                <p v-for="(menu, index) in $store.state.text.pages.bottomMenu.right"
                   class="bottomMenu ma-0 pointer"
                   :key="menu.name + index"
                   @click="$router.push(menu.link)">
                  {{ menu.name }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

    </v-toolbar>
    <v-toolbar
      color="primary"
      dense
      height="30"
      bottom
    >
      <v-container>
        <v-row no-gutters justify="center">
          <v-col sm="12" md="6" offset-md="2" class="bottomMenu">
            {{ $store.state.text.pages.bottomMenu.copy }}
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'BottomBar',
};
</script>

<style scoped>
.bottomMenu {
  color: #ffffff;
}

.bottomBar {
  margin-top: -10em;
}

.logo {
  margin-bottom: -3em;
}
</style>
